import { NOTIFICATION_REDIRECTION_KEY } from '@shared/constants';
import { useNotificationCount } from './hooks/use-get-notification-count';
import { useGetNotification } from './hooks/use-get-notifications';
import { useMarkAllRead } from './hooks/use-mark-all-read';
import { useMarkSingleRead } from './hooks/use-mark-notification-read';
import { useNotificationToggle } from './hooks/use-notification-toggle';
import { UseNotificationReturn } from './notification.types';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ALL_MEMBERS_ROUTE } from '@modules/conversations/features/all-members-conversation/all-members-conversation.constants';

export function useNotification(): UseNotificationReturn {
  const navigate = useNavigate();

  const [markedNotificationIds, setMarkedNotificationIds] = useState<number[]>([]);
  const notificationSeen = useNotificationCount();
  const notifications = useGetNotification();
  const firstNotificationId = notifications?.data?.data?.[0]?.id;

  const fetchNotifications = () => {
    notifications.fetchQuery({
      variables: {},
    });
  };

  const dropdownToggle = useNotificationToggle(
    fetchNotifications,
    markedNotificationIds,
    firstNotificationId,
    setMarkedNotificationIds
  );
  const markAllRead = useMarkAllRead();
  const markSingleRead = useMarkSingleRead();

  const handleMarkedNotification = (id: number) => {
    setMarkedNotificationIds((prev) => (prev.includes(id) ? prev.filter((number) => number !== id) : [...prev, id]));
  };

  const onClickNotification: UseNotificationReturn['onClickNotification'] = (notification) => () => {
    const { redirectUrl = '', id, isExternal, redirection } = notification;

    if (!id) return;
    handleMarkedNotification(id);
    markSingleRead.markSingleReadHandler(id, true);
    dropdownToggle.closeNotification();

    if (redirection) {
      const { key, params } = redirection;

      if (key === NOTIFICATION_REDIRECTION_KEY.CHAT_BOX) {
        navigate(`/conversations/${params?.channelId}/${params?.clientId}`);
        return;
      }

      if (key === NOTIFICATION_REDIRECTION_KEY.ALL_MEMBERS_CHAT) {
        navigate(ALL_MEMBERS_ROUTE);
        return;
      }

      if (key === NOTIFICATION_REDIRECTION_KEY.MEMBER_CHAT) {
        navigate(`/conversations/member/${params?.memberId}`);
        return;
      }
    }
    if (!redirectUrl || redirectUrl === 'undefined') return;

    if (isExternal) {
      window.open(redirectUrl, '_blank');
      return;
    }
    navigate(redirectUrl);
  };

  return {
    notificationSeen,
    dropdownToggle,
    notifications,
    markAllRead,
    markSingleRead,
    onClickNotification,
    markedNotificationIds,
    handleMarkedNotification,
  };
}
